<div class="preview-content-root">
  @if (view && response) {
    @switch (view.type) {
      @case ("QUEST_PASSWORD") {
        <app-password-page
          [previewMode]="previewMode"
          (responseChange)="handleResponseChange($event)"
          [response]="response"
        ></app-password-page>
      }
      @case ("SURVEY_PAGE") {
        <app-survey-page
          (responseChange)="handleResponseChange($event)"
          [previewMode]="previewMode"
          [response]="response"
        ></app-survey-page>
      }
      @case ("INFORMATION") {
        <app-information-page
          (responseChange)="handleResponseChange($event)"
          [previewMode]="previewMode"
          [response]="response"
        ></app-information-page>
      }
      @case ("GDPR_CONSENT") {
        <app-gdpr-page
          (responseChange)="handleResponseChange($event)"
          [previewMode]="previewMode"
          [response]="response"
        ></app-gdpr-page>
      }
      @case ("CHOOSE_LANGUAGE") {
        <app-language-page
          (responseChange)="handleResponseChange($event)"
          [previewMode]="previewMode"
          [response]="response"
        ></app-language-page>
      }
    }
  }
</div>
